import { User } from '../models/user';

/**
 * Map to group admin and learner data in query or body.
 * @param {object} data Group admin.
 * @param {User | undefined} [data.groupAdmin] Group admin.
 * @param {User | undefined} [data.learner] Learner.
 * @returns {object}
 */
function toDto({ groupAdmin, learner }) {
  return {
    group_admin_id: groupAdmin?.id,
    user_id: learner?.id,
  };
}

export const managerRequestMapper = {
  toDto,
};
